export const frequencies = [
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Quarterly', label: 'Quarterly' },
  { value: 'Half-Yearly', label: 'Half-Yearly' },
  { value: 'Annually', label: 'Annually' },
  { value: 'One-time', label: 'One-time' },
] as const;

export type FrequencyValue = (typeof frequencies)[number]['value'];

export function getFrequencyLabel(value: string): string {
  const frequency = frequencies.find((freq) => freq.value === value);
  return frequency?.label || value;
}

// Default frequencies for categories
export const defaultCategoryFrequencies: Record<string, FrequencyValue> = {
  RENT: 'Monthly',
  MORTGAGE: 'Monthly',
  HOA: 'Monthly',
  PROPERTY_TAX: 'Half-Yearly',
  INSURANCE: 'Annually',
  MANAGEMENT: 'Monthly',
  UTILITIES: 'Monthly',
  MAINTENANCE: 'One-time',
  CAPEX: 'One-time',
  OTHER_INCOME: 'Monthly',
  OTHER_EXPENSE: 'Monthly',
} as const;

export function getDefaultFrequencyForCategory(
  category: string,
): FrequencyValue {
  return defaultCategoryFrequencies[category] || 'Monthly';
}
